import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { SpaceBetweenContainer } from '../../../../../healtheraComponents';
import { Column, FormContainer, Section } from '../../../../Services/styled-components';
import { Questionnaire } from '../../../types';
import QuestionsList from '../QuestionsList/QuestionsList';
import TitleEditor from './components/TitleEditor';
import { selectQuestions } from '../../../../../redux/questionnaire/selectors';
import { useSyncQuestionnaireQuestions } from './hooks/useSyncQuestionnaireQuestions';
import { usePutQuestionsToRedux } from './hooks/usePutQuestionsToRedux';
import DeleteButton from './components/DeleteButton';
import CreateButton from './components/CreateButton';
import UpdateButton from './components/UpdateButton';
import QuestionnaireHeader from './components/QuestionnaireHeader';
import { useSyncBlockingAnswers } from './hooks/useSyncBlockingAnswers';
import { usePutBlockingAnswersToRedux } from './hooks/usePutBlockingAnswersToRedux';

interface Props {
  questionnaire: Questionnaire;
  refetchQuestionnaire: () => void;
}

export default function QuestionnaireViewerEditor({ questionnaire, refetchQuestionnaire }: Readonly<Props>) {
  const isExistingQuestionnaire = Boolean(questionnaire?._id);
  const questions = useSelector(selectQuestions);

  const { control, handleSubmit, setValue, formState, reset } = useForm<Questionnaire>({
    defaultValues: questionnaire
  });

  useSyncQuestionnaireQuestions(setValue);
  useSyncBlockingAnswers(setValue);
  usePutQuestionsToRedux(questionnaire);
  usePutBlockingAnswersToRedux(questionnaire);

  useEffect(() => {
    reset(questionnaire);
  }, [reset, questionnaire]);

  return (
    <Container>
      <SpaceBetweenContainer>
        <QuestionnaireHeader isFormDirty={formState.isDirty} />
      </SpaceBetweenContainer>
      <FormContainer>
        <Column>
          <Section>
            <header>Title</header>
            <TitleEditor control={control} />
          </Section>
          <Section>
            <header>Questions</header>
            <QuestionsList questions={questions} />
          </Section>
        </Column>
        <ActionSection style={{ gridColumn: 'span 2' }}>
          <DeleteButton questionnaire={questionnaire} />
          {isExistingQuestionnaire ? (
            <UpdateButton handleSubmit={handleSubmit} reset={reset} refetchQuestionnaire={refetchQuestionnaire} />
          ) : (
            <CreateButton handleSubmit={handleSubmit} />
          )}
        </ActionSection>
      </FormContainer>
    </Container>
  );
}

const Container = styled.div`
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ActionSection = styled.section`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
`;
